import { useEffect } from 'react';

// Escape closes the top-most dialog via its own close button (all editor-backdrop dialogs)
export default function EscCloser() {
  useEffect(() => {
    const k = (e) => {
      if (e.key !== 'Escape' || document.querySelector('[data-testid=confirm-dialog]')) return;
      const top = [...document.querySelectorAll('.editor-backdrop, .place-picker')].pop();
      const b = top?.querySelector('[data-testid$="close-btn"], [data-testid=place-cancel-btn]');
      if (b) { e.preventDefault(); b.click(); }
    };
    window.addEventListener('keydown', k, true);
    return () => window.removeEventListener('keydown', k, true);
  }, []);
  return null;
}
